import React from 'react';
import PropTypes from 'prop-types';
import { ApIcon } from '@alixpartners/ui-components';
import { ApSignalrConsumer } from '@alixpartners/ui-utils';
import { brandColors } from 'styles/colors';
import UploadProgressBar from '../UploadProgressBar';

import { SuccessMessage, MessageWrapper } from './styles';
import { StepWrapper } from '../styles';

class SpendCubeGeneration extends React.Component {
	static propTypes = {
		fetchState: PropTypes.func.isRequired,
		onUploadCompleted: PropTypes.func.isRequired,
		isDirect: PropTypes.bool,
	};

	state = {
		isSuccess: false,
		statusMessage: '',
		currentUploadStep: 0,
		totalUploadSteps: 1,
	};

	render() {
		const {
			isSuccess,
			statusMessage,
			currentUploadStep,
			totalUploadSteps,
		} = this.state;
		const { fetchState, onUploadCompleted, isDirect } = this.props;
		const initialMessage = isDirect
			? 'Starting spend cube generation'
			: 'Starting auto classification';

		if (isSuccess) {
			return (
				<StepWrapper>
					<MessageWrapper>
						<ApIcon
							iconName="outline_check_circle_outline"
							iconSize="32px"
							iconColor={brandColors.green}
						/>
						<SuccessMessage>
							Spend cube successfully published, you can now access your data
						</SuccessMessage>
					</MessageWrapper>
				</StepWrapper>
			);
		}

		return (
			<React.Fragment>
				<UploadProgressBar
					label={statusMessage || initialMessage}
					value={Math.floor((100 * currentUploadStep) / totalUploadSteps)}
				/>

				<ApSignalrConsumer
					message="UploadProcessing"
					onMessage={(
						messageName,
						statusMessage,
						currentUploadStep,
						totalUploadSteps
					) => {
						this.setState({
							statusMessage,
							currentUploadStep,
							totalUploadSteps,
						});
					}}
				/>
				<ApSignalrConsumer
					message="UploadCompleted"
					onMessage={() => {
						this.setState(
							{
								statusMessage: '',
								isSuccess: true,
							},
							onUploadCompleted
						);
					}}
				/>
				<ApSignalrConsumer
					message="UploadFailed"
					onMessage={() => {
						fetchState();
					}}
				/>
			</React.Fragment>
		);
	}
}

export default SpendCubeGeneration;
